import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["title", "aria-label"]

import Tooltip from '@/components/common/tooltip/Tooltip.vue';
import { ref } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'Hint',
  props: {
    helpText: { default: undefined },
    size: { default: 'small' },
    position: { default: 'top' }
  },
  setup(__props: any) {



const tooltipOpened = ref(false);
const targetElement = ref<HTMLElement | undefined>();

function onFocusSpan(event: FocusEvent) {
  targetElement.value = event.target as HTMLElement;
  tooltipOpened.value = true;
}

function blur() {
  targetElement.value = undefined;
  tooltipOpened.value = false;
}

function onMouseEnter(event: MouseEvent) {
  targetElement.value = event.target as HTMLElement;
  tooltipOpened.value = true;
}

return (_ctx: any,_cache: any) => {
  return (__props.helpText)
    ? (_openBlock(), _createBlock(Tooltip, {
        key: 0,
        "open-delay": 0,
        "anchor-element": 'target',
        position: __props.position,
        open: tooltipOpened.value,
        "target-element": targetElement.value
      }, {
        default: _withCtx(() => [
          _createElementVNode("i", {
            title: __props.helpText,
            "aria-label": __props.helpText,
            tabindex: "0",
            role: "button",
            class: _normalizeClass(["hint cwx-icon cwx-icon-before_question-default", {
        'hint--small': __props.size === 'small',
        'hint--medium': __props.size === 'medium',
      }]),
            onFocus: onFocusSpan,
            onBlur: blur,
            onMouseenter: onMouseEnter,
            onMouseleave: blur
          }, null, 42, _hoisted_1)
        ]),
        _: 1
      }, 8, ["position", "open", "target-element"]))
    : _createCommentVNode("", true)
}
}

})